export default "__VITE_ASSET__CmYId3Vy__"